



















































































































































































import {Component, Model, Prop, Vue, Watch} from 'vue-property-decorator'
import InputComp, {InputField} from "@/components/general/InputComp.vue";
import Webservice from "@/assets/service/Webservice";
import {RequestType} from "@/assets/constants/Enums";
import {SchoolURLParams} from "@/assets/service/Endpoints";
import GenericEntity from "@/assets/Entities/GenericEntity";
import {makeId} from "@/assets/util/IdUtil";
import DatePicker from "@/components/contacts/DatePicker.vue";
import pdf from "vue-pdf";

@Component({components: {DatePicker, InputComp, pdf}})
export default class GenericEntityEditor<T extends GenericEntity> extends Vue {
  openDialog: boolean = false;
  showSafetyDialog: boolean = false;
  canBeDeleted: boolean = true;

  rndKey: string = makeId(5);

  @Model() model!: T;

  @Prop() reloadCallback!: () => void;

  editableEntity!: T;

  get withUpload(): boolean {
    return false;
  }

  uploadLabel: string = '';

  image: any = null;
  uploadDialogOpen: boolean = false;
  uploadActivator1: string = '';
  uploadActivator2: string = '';
  dialogModeA: Boolean = true;

  uploadSuccess: boolean = false;

  get uploadTitle(): string {
    return '';
  }

  imgASource: string = '';
  imgALabel: string = '';

  imgBSource: string = '';
  imgBLabel: string = '';

  imgAext: string = '';
  imgBext: string = '';

  uploadButton: string = '';

  uploadImage!: () => void;
  uploadUntil: String = '';

  title!: string;
  fields!: InputField<GenericEntity>[];

  params!: SchoolURLParams;

  createCleanEntity(): T {
    throw new Error('Never ever call this! Overwrite it!')
  };

  loading: boolean = false;

  @Watch('openDialog')
  loadEntity() {
    if (this.openDialog && !this.create) {
      this.loading = true;
      Webservice.performRequest<T>(RequestType.GET, this.params, {}, (val) => {
        this.editableEntity = (val as T);
        this.entityPreparation();
        this.rndKey = makeId(5);
      }, error => {
      }, () => {
        this.loading = false
      })
    }
  }

  get create(): boolean {
    return this.model === undefined;
  }

  entityPreparation() {
  }

  save(): void {
    this.loading = true;
    Webservice.performRequest(this.create ? RequestType.POST : RequestType.UPDATE, this.params,
        this.editableEntity, val => {
          this.reloadCallback();
          this.clearAndHide();
        }, error => {/* TODO: handle me */
        }, () => {
          this.loading = false;
        })
  }

  deleteEntity() {
    this.loading = true;
    Webservice.performRequest(RequestType.DELETE, this.params, this.editableEntity, val => {
          this.reloadCallback();
          this.clearAndHide();
        }, error => {/*TODO handle */
        },
        () => {
          this.loading = false
        })
  }

  safeToCancel() {
    this.showSafetyDialog = false;
    this.clearAndHide();
  }

  isDirty(): boolean {
    return true
  };

  closeDialog(): void {
    if (this.isDirty()) {
      this.showSafetyDialog = true;
    } else {
      this.clearAndHide();
    }
  }

  protected clearAndHide(): void {
    this.editableEntity = this.create ? this.createCleanEntity() : this.model;
    this.openDialog = false;
  }

  created() {
    this.openDialog = false;
    this.editableEntity = this.create ? this.createCleanEntity() : this.model;
  }
}
